import { Toast, Notification, Modal } from 'wbap-components'
import { fetch } from 'wbap-utils'

let options = {}

fetch.config({
  // 对发起请求前做统一处理
  before: (url, data, headers) => {

  },
  // 对restful api统一做返回值或者异常处理
  after: (response, url) => {
    if (response.result) {
      if (response.token) {
        fetch.config({token: response.token})
      }
      console.log(response.value)
      return response.value
    }
    else {
      Toast.error(response.error.message)
      throw {url, response}
    }
  }
})

export default function config (_options) {
  Object.assign(options, _options)

  options.targetDomId = 'root' //react render到目标dom
  options.startAppName = 'wbap-admin-root' //启动app名，需要根据实际情况配置

  options.toast = Toast //轻提示使用组件
  options.notification = Notification //通知组件
  options.modal = Modal //模式弹窗组件

  return options
}


// WEBPACK FOOTER //
// ./src/config.js